<template>
  <erp-s-field
      :view="this.fieldView || 'tl'"
      :label="label || 'Tipo'"
      :helper="helper"
      :helper-position="helperPosition || 'lb'"
      :error="error"
      :label-width="labelWidth"
      :style="fieldStyle"
  >
    <erp-select
        @input="__set"
        :multiple="multiple"
        :placeholder="!selectNull ? placeholder || 'Qualquer' : ''"
        :options="status"
        v-model="model"
        propoverClass="select-status-def1"
        :disable="disable"
        :style="inputStyle"
        :simple-border="simpleBorder"
    >
    </erp-select>
  </erp-s-field>
</template>

<script>
import SelectMixin from '../../../../../mixins/SelectMixin'
import {TIPOS_PROCESSO} from '@/domain/processos/helpers/tipo-processo'

export default {
  name: 'TipoProcessoSelect',
  mixins: [SelectMixin],
  props: {
    selectNull: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    status () {
      let keys = Object.keys(TIPOS_PROCESSO).map((k) => {
        return {
          label: TIPOS_PROCESSO[k].label,
          value: Number(k),
          class: typeof TIPOS_PROCESSO[k].title !== 'undefined' ? TIPOS_PROCESSO[k].class : null
        }
      })
      if (this.selectNull) {
        keys.unshift({
          label: 'Qualquer',
          value: ''
        })
      }
      return keys
    }
  },
  components: {},
  methods: {
    __updateInternal () {
      this.$nextTick(() => {
        if (this.value !== 'undefined' && this.value !== null && this.model === null) {
          let _cp = JSON.stringify(this.value) // force to update datepicker with actual value
          this.model = ''
          setTimeout(() => {
            this.model = JSON.parse(_cp)
          }, 1)
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.select-status-def1 {
  td {
    display flex
    justify-items center
  }
}
</style>
